var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-row",class:{ 'mobile-column': _vm.mobileColumn }},[_c('span',{style:({width: _vm.width + 'ch' })},[_vm._v(_vm._s(_vm.left))]),(_vm.titleIsH1)?_c('h1',[_vm._v(_vm._s(_vm.center))]):_c('span',[_vm._v(_vm._s(_vm.center))]),_c('span',{style:({width: _vm.width + 'ch' })},[_vm._v(_vm._s(_vm.right))])])
}
var staticRenderFns = []

export { render, staticRenderFns }